// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fotter_FotterBox__CFl2w {
    width: 100%;
    height: 30px;
    margin-top: 50px;
    margin-bottom: 14px;
    box-sizing: border-box;
    background-color: #7B8073;
}
.fotter_FotterBox__CFl2w p {
    margin: 0%;
    font-size: 9px;
    color: #111A00;
    margin-top: 10px;
}

@media (min-width: 1200px) {
    .fotter_FotterBox__CFl2w {
        height: 70px;
        margin-top: 100px;
    }
    .fotter_FotterBox__CFl2w p {
        font-size: 25px;
        margin-top: 20px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/fotter/fotter.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;AAC7B;AACA;IACI,UAAU;IACV,cAAc;IACd,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI;QACI,YAAY;QACZ,iBAAiB;IACrB;IACA;QACI,eAAe;QACf,gBAAgB;IACpB;AACJ","sourcesContent":[".FotterBox {\r\n    width: 100%;\r\n    height: 30px;\r\n    margin-top: 50px;\r\n    margin-bottom: 14px;\r\n    box-sizing: border-box;\r\n    background-color: #7B8073;\r\n}\r\n.FotterBox p {\r\n    margin: 0%;\r\n    font-size: 9px;\r\n    color: #111A00;\r\n    margin-top: 10px;\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n    .FotterBox {\r\n        height: 70px;\r\n        margin-top: 100px;\r\n    }\r\n    .FotterBox p {\r\n        font-size: 25px;\r\n        margin-top: 20px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"FotterBox": `fotter_FotterBox__CFl2w`
};
export default ___CSS_LOADER_EXPORT___;
